import React from 'react';

export default function Hero() {
  return (
    <div className="hero">
      <h1>I AM JASON GATES</h1>
      <h3>Full Stack Software Engineer</h3>
      <button type="button">Projects</button>
    </div>
  );
}
